/* Fuentes Distribution — comportamiento compartido de las secciones fd-* */
(function () {
  if (window.FD) return;
  window.FD = {};

  /* Flechas para cualquier [data-fd-carousel] que contenga .fd-track */
  function initCarousel(root) {
    if (root.dataset.fdReady) return;
    root.dataset.fdReady = '1';
    var track = root.querySelector('.fd-track');
    var prev = root.querySelector('[data-fd-prev]');
    var next = root.querySelector('[data-fd-next]');
    if (!track) return;

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (item.offsetWidth + gap)));
      return perView * (item.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  FD.initCarousels = function (scope) {
    (scope || document).querySelectorAll('[data-fd-carousel]').forEach(initCarousel);
  };

  /* Agregar al carrito: usa la API AJAX y notifica al cajón de carrito de Horizon */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-fd-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var body = new FormData(form);

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw json;
          return json;
        });
      })
      .then(function () {
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: cart,
          sourceId: form.id || 'fd-card',
          data: { source: 'fd-product-card', itemCount: cart.item_count, variantId: body.get('id') },
        };
        document.dispatchEvent(evt);
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function (err) {
        alertFallback(btn, (err && (err.description || err.message)) || 'No se pudo agregar');
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  });

  function alertFallback(btn, msg) {
    if (!btn) return;
    var original = btn.textContent;
    btn.textContent = msg;
    setTimeout(function () { btn.textContent = original; }, 2500);
  }

  /* Revelar al hacer scroll */
  FD.reveal = function (el, cls) {
    if (!('IntersectionObserver' in window)) { el.classList.add(cls); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { el.classList.add(cls); io.disconnect(); }
      });
    }, { threshold: 0.1 });
    io.observe(el);
  };

  function boot() { FD.initCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { FD.initCarousels(e.target); });
})();

/* Triqui de Halloween (script externo de BeMastery): ese script refresca el carrito con
   selectores del tema anterior; aquí avisamos al carrito de Horizon para que muestre el premio. */
(function () {
  var timer = null;
  function refreshCart() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var evt = new Event('cart:update', { bubbles: true });
          evt.detail = { resource: cart, sourceId: 'fd-triqui', data: { source: 'fd-triqui', itemCount: cart.item_count } };
          document.dispatchEvent(evt);
        })
        .catch(function () {});
    }, 2500);
  }
  ['halloween:gameCompleted', 'halloween:closed'].forEach(function (name) {
    document.addEventListener(name, refreshCart);
  });
})();

/* Entrada suave de secciones y tarjetas al hacer scroll. No toca lo que ya está en pantalla al cargar. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  var GROUPS = '.fd-track, .fd-offers__list, .fd-goals__grid, .fd-wa__perks, .fd-trust__grid';
  var SINGLES = '.fd-title, .fd-offers__head, .fd-goals__tabs, .fd-goals__intro, .fd-cta, .fd-seo';
  function setup() {
    var vh = window.innerHeight;
    var items = [];
    document.querySelectorAll('main ' + SINGLES).forEach(function (el) { items.push(el); });
    document.querySelectorAll('main ' + GROUPS).forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, n) {
        c.style.setProperty('--fd-i', Math.min(n, 5));
        items.push(c);
      });
    });
    var pending = items.filter(function (el) { return el.getBoundingClientRect().top > vh * 0.92; });
    if (!pending.length) return;
    pending.forEach(function (el) { el.classList.add('fd-rv'); });
    document.documentElement.classList.add('fd-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var group = e.target.parentElement && e.target.parentElement.matches(GROUPS) ? e.target.parentElement : null;
        (group ? Array.prototype.slice.call(group.children) : [e.target]).forEach(function (el) {
          el.classList.add('is-in');
          io.unobserve(el);
          setTimeout(function () { el.classList.remove('fd-rv', 'is-in'); el.style.removeProperty('--fd-i'); }, 1500);
        });
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });
    pending.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
